module.exports = __webpack_public_path__ + "media/customizations/lifeatkiawahriver/back-df4aa92af25d47b8ca900e511f482214.jpg";